
import img0 from './Images/GrantClientAccess.png';
import img1 from './Images/GrantResourceAccess.png';
  
const content = `# OnData Client Resource Access

Once a OnData client (the OnData Encryption Tool or OnData database driver) is successfully registered and activated with the OnData Platform, the client needs to be 
granted access to certain resources (databases or file templates), so that the OnData client can access such resources. There are two ways to manage client access to 
resources: 1) under client settings, grant a client access to one or more databases or file templates; 2) under resource settings of a particular database or file 
template, grant access to one or more clients. Either approach can be used to grant a OnData client access to resources.  
  
## 1. Grant Client Access to Resources  
a. Login to the OnData Portal, and navigate to \`Settings -> Organization -> Clients\`  
b. Based on the client type, select \`Database Driver\` or \`Encryption Tool\` (Note that the \`SecureFile App\` does not require access control)  
c. Select the \`Active\` tab to view the list of active clients  
d. Identify the client of interest, mouse over the \`+\` sign on the right, and select the \`Assign Resources\` button  
e. On the \`Assign Resources\` page, select the \`Database\` tab or the \`File Template\` tab, depending on the type of resource  
f. Search the desire resources by name. The dropdown list will be dynamically filtered by the input. You can select one resource from the list, or click on the 
"Add All" button at the right side of \`Search to add...\` box to add all resources in the filtered list  
g. Click on the \`Save\` button to grant this client access to the newly added resource(s)   
  
![Grant Client Access to Resources](${ img0 })  
  
## 2. Assign Clients to Resource  
a. Login to the OnData Portal, and navigate to \`Services -> Encryption -> Encryption Mappings\`  
b. Based on the client type, select the \`Database\` tab or the \`File\` tab  
c. Identify the resource of interest and select the \`Assign Clients\` button  
d. On the \`Assign Clients\` page, search the desire clients by name. The dropdown list will be dynamically filtered by the input. You can select one client from the 
list, or click on the "Add All" button at the right side of \`Search to add...\` box to add all clients in the filtered list  
e. Click on the \`Save\` button to grant the newly added client(s) access to this resource  
  
![Grant Resource Access to Clients](${ img1 })  
  `
  
export default content;
